<form [formGroup]=form>
	<h4 class="bk-modal__section-title">
		{{'Calculate Sprinkler Application Rate' | translate }}
	</h4>
	<label class="bk-modal__label">
		{{'Sprinkler Type' | translate}}
	</label>
	<select class="bk-modal__field"
		formControlName="Type">

		<option 
			*ngFor="let sprinklerType of sprinklerTypes"
			[ngValue]="sprinklerType.Id">
			{{sprinklerType.Name}}
		</option>
	</select>
	<div class="bk-form-group">
		<div class="bk-modal__right-four-col">
			<label class="bk-modal__label">
				{{'Nozzle Diameter' | translate}}
			</label>
			<select class="bk-modal__field--with-unit bk-modal__field"
				formControlName="NozzleDiameter">

				<option *ngFor='let nozzleDiameter of nozzleDiameters'
					[ngValue]='nozzleDiameter.id'>
					{{nozzleDiameter.name}}
				</option>
			</select>
			<div class="bk-modal__field-unit">
				{{'in' | translate}}
			</div>
		</div>
		<div class="bk-modal__right-four-col">
			<label class="bk-modal__label">
				{{'Nozzle Pressure' | translate}}
			</label>
			<select class="bk-modal__field--with-unit bk-modal__field"
				formControlName="NozzlePressure">
				<option [ngValue]="25">25</option>
				<option [ngValue]="30">30</option>
				<option [ngValue]="35">35</option>
				<option [ngValue]="40">40</option>
				<option [ngValue]="45">45</option>
				<option [ngValue]="50">50</option>
				<option [ngValue]="55">55</option>
				<option [ngValue]="60">60</option>
				<option [ngValue]="65">65</option>
			</select>
			<div class="bk-modal__field-unit">
				{{'psi' | translate}}
			</div>
		</div>
		<div class="bk-modal__right-four-col">
			<label class="bk-modal__label">
				{{'Lateral Pipe Spacing' | translate}}
			</label>
			<input class="bk-modal__field--with-unit bk-input--x-short bk-modal__field"
				type="number"
				step="0.01"
				formControlName="PipeSpacing"/>
			<div class="bk-modal__field-unit">
				{{'ft' | translate}}
			</div>
		</div>
		<div class="bk-modal__right-four-col">
			<label class="bk-modal__label">
				{{'Sprinkler Head Spacing' | translate}}
			</label>
			<input class="bk-modal__field--with-unit bk-input--x-short bk-modal__field"
				type="number"
				step="0.01"
				formControlName="HeadSpacing"/>
			<div class="bk-modal__field-unit">
				{{'ft' | translate}}
			</div>
		</div>
	</div>
	<div class="bk-modal__section-buttons">
		<button class="bk-button bk-button--medium bk-button--text-only"
			(click)="cancel($event)">
			{{'Cancel' | translate }}
		</button>
		<button class="bk-button bk-button--medium"
			[disabled]="form.invalid"
			(click)="calculate($event)">
			{{'Calculate' | translate }}
		</button>
	</div>
</form>